<template>
<div class="container-fluid main-content">
    <div class="row">
        <div class="col-12">
            <div class="row">
                <div class="col-md-10 offset-md-1 col-lg-4  col-xl-4 offset-lg-1">
                    <div class="article-cover__text-block">
                        <p class="tagline article-cover__tagline">{{ content.tagline }}</p>
                        <h1 class="heading heading--1 article-cover__heading">{{ content.title }}</h1>
                        <lead-text></lead-text>
                    </div>
                </div>
                <div class="main-content__wheel offset-md-1 col-md-10 col-lg-5 offset-lg-1 col-xl-5 offset-xl-1">
                    <wheel-of-fortune></wheel-of-fortune>
                </div>
            </div>
        </div>
    </div>
</div>
</template>
<script>
    import LeadText from "./LeadText";
    import WheelOfFortune from "./WheelOfFortune";
    export default {
        components: {WheelOfFortune, LeadText},
        props: ["content"]
    }
</script>

<style lang="scss">
    .main-content {
        margin-bottom: 100px;

        &__wheel {
            @media (max-width: 1203px) {
                margin-top: 50px;
            }
        }

        .article-cover__heading {
            @media (min-width: 1204px) {
                font-size: 3.2vw;
                line-height: 1.1;
            }
        }
    }
</style>


